module.exports = __webpack_public_path__ + "static/media/client-credentials-grant.9dc601f9.jpg";